import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ProblemModel, ProblemRequest, ProblemPaginator } from '@generativ/much-smarter-models';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ErrorHandlerService } from '../core/services/error-handler.service';
import { environment } from '../../environments/environment';


export interface IAnswerType {
  value: string;
  title: string;
}

@Injectable({ providedIn: 'root' })
export class ProblemService {

  private problemsURL = environment.msApiUrl + 'problems/';

  constructor(private http: HttpClient, private errorHandlerService: ErrorHandlerService) {
  }

  createProblem(problem: ProblemRequest.Create): Observable<ProblemModel> {
    return this.http.post<ProblemModel>(this.problemsURL, problem).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  updateProblem(id: number, problem: ProblemRequest.Update): Observable<ProblemModel> {
    return this.http.patch<ProblemModel>(this.problemsURL + id, problem).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  getProblemsWithPagination(offset: number,
                            limit?: number,
                            sortBy?: string,
                            searchQuery?: string,
                            subject?: string): Observable<ProblemPaginator> {
    let url = `${this.problemsURL}?offset=${offset}&limit=${limit}`;
    if (sortBy) {
      url = url + `&sortBy=${sortBy}`;
    }
    if (searchQuery) {
      url = url + `&searchQuery=${searchQuery}`;
    }
    if (subject) {
      url = url + `&subject=${subject}`;
    }
    return this.http.get<ProblemPaginator>(url).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  getProblem(id: number): Observable<ProblemModel> {
    return this.http.get<ProblemModel>(this.problemsURL + id).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  getAnswerTypes(): IAnswerType[] {
    const answerTypes: IAnswerType[] = [
      {value: 'MARKDOWN', title: 'Markdown'},
      {value: 'MATH_MARKDOWN', title: 'Markdown for Math'},
      {value: 'IMAGE', title: 'Image'},
    ];

    return answerTypes;
  }

  checkUniqueTitle(title: string): Observable<boolean> {
    return this.http.post<boolean>(this.problemsURL + 'checkTitle', title).pipe(
      catchError(this.errorHandlerService.handleError));
  }
}
